import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class DeleteAllowedDomainRPC implements
  LeoRPC<DeleteAllowedDomainRPC.Request, DeleteAllowedDomainRPC.Response, DeleteAllowedDomainRPC.Errors.Errors>
{
  abstract execute(
    request: DeleteAllowedDomainRPC.Request
  ): Promise<LeoRPCResult<DeleteAllowedDomainRPC.Response, DeleteAllowedDomainRPC.Errors.Errors>>;
}

export namespace DeleteAllowedDomainRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    domainId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isDeleteAllowedDomainRPCRequest: boolean = true;
  
    readonly domainId: LeoUUID;
  
  
    constructor(
    domainId: LeoUUID
    ) {
      this.domainId = domainId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const domainId = getLeoUuid(dto, "domainId", InvalidRequestDomainIdError);
      return new Request(
        domainId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          domainId: this.domainId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `DeleteAllowedDomainRPC(domainId='${this.domainId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `DeleteAllowedDomainRPC.Response()`;
  };

  export enum RPCError {
    DomainNotFound = "DOMAIN_NOT_FOUND"
  }

  export namespace Errors {
    
    export interface DomainNotFoundDTO {
      code: string;
    }
    
    export class DomainNotFound extends LeoRPCError<RPCError> {
      readonly isDomainNotFound: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.DomainNotFound;
        super(code);
      }
    
    
      toDTO(): DomainNotFoundDTO {
        const dto: DomainNotFoundDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    DomainNotFound.prototype.toString = function toString(): string {
      return `DeleteAllowedDomainRPC.DOMAIN_NOT_FOUND()`;
    };
    

    export type Errors = DomainNotFound;
    export type ErrorsDTO = DomainNotFoundDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.DomainNotFound:
          return new DomainNotFound();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestDomainIdError extends DeleteAllowedDomainRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestDomainIdError";
  }
}


export class InvalidResponseDomainNotFoundError extends DeleteAllowedDomainRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDomainNotFoundError";
  }
}

